var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2590_541)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2590_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.745 12.77C23.745 11.98 23.675 11.23 23.555 10.5H12.255V15.01H18.725C18.435 16.49 17.585 17.74 16.325 18.59V21.59H20.185C22.445 19.5 23.745 16.42 23.745 12.77Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.255 24.5C15.495 24.5 18.205 23.42 20.185 21.59L16.325 18.59C15.245 19.31 13.875 19.75 12.255 19.75C9.12498 19.75 6.47498 17.64 5.52498 14.79H1.54498V17.88C3.51498 21.8 7.56498 24.5 12.255 24.5Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52501 14.7901C5.27501 14.0701 5.145 13.3001 5.145 12.5001C5.145 11.7001 5.28501 10.9301 5.52501 10.2101V7.12012H1.545C0.725004 8.74012 0.255005 10.5601 0.255005 12.5001C0.255005 14.4401 0.725004 16.2601 1.545 17.8801L5.52501 14.7901Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.255 5.25C14.025 5.25 15.605 5.86 16.855 7.05L20.275 3.63C18.205 1.69 15.495 0.5 12.255 0.5C7.56498 0.5 3.51498 3.2 1.54498 7.12L5.52498 10.21C6.47498 7.36 9.12498 5.25 12.255 5.25Z",
    fill: "#EA4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2590_541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2590_541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.749f5bb38f36f2cd8378a9c5f648cd68.svg";
export { ForwardRef as ReactComponent };